<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('business.edit.title')"
        )

        v-container.grid-list-lg(fluid)
            v-layout(raw wrap)
                v-flex(xs12 md6)
                    div.padderRight.mb-3

                        // Form title
                        title-component(type="h4" :title="$t('business.edit.subtitle')")

                        // Edit form
                        edit-form(ref="form")

                v-flex(xs12 md6)
                    div.padderLeft.mb-3
                        title-component(type="h4" :title="$t('business.edit.settings.title')")

                        //Account settings
                        account-settings

                        // Horizontal line
                        separator-component

                        div
                            title-component(type="h4" :title="$t('business.edit.settings.uploadTitle')")

                            //Upload Avatar
                            upload-component(:userId="id")

        program

        v-container.grid-list-lg(fluid)
            v-layout(raw wrap)
                v-flex(xs12)

                    separator-component

                    div.controls

                        div

                            // Cancel button
                            button-component.ml-0(
                                :action="cancel"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="grey"
                                large
                                outline
                            ) {{ $t('defaultButtons.cancel') }}

                        div

                            // Submit button
                            button-component.mr-0.submit(
                                :action="submit"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="primary"
                                large
                            ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Layout from '../../Layout/Layout';
    import AccountSettings from './AccountSettings';
    import EditForm from './EditForm';
    import VueTypes from 'vue-types';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import LogoUpload from '~components/LogoUpload';
    import { mapActions, mapGetters } from 'vuex';
    import Program from '../Program';

    export default {
        components: {
            Layout,
            AccountSettings,
            EditForm,
            Program,
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            TitleComponent: Title,
            UploadComponent: LogoUpload
        },
        props: {
            id: VueTypes.string.def('')
        },
        computed: {
            ...mapGetters('businesses', ['isLoading'])
        },
        beforeMount() {
            this.read(this.id);
        },
        beforeRouteLeave(to, from, next) {
            this.resetBusiness();
            next();
        },
        methods: {
            ...mapActions('businesses', ['read', 'cancel', 'resetBusiness']),

            /**
             * Update business account
             */
            submit() {
                this.$refs.form.submitForm();
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    @media screen and (min-width: $grid-breakpoints.md)
        .padderRight
            padding-right: 20px

        .padderLeft
            padding-left: 20px
</style>
